<template>
  <base-section
    id="flow"
    title="ご利用の流れ"
    subtitle="初めての方でも安心してご利用いただけます"
    background="light"
  >
    <div class="flow-section">
      <div class="flow-steps">
        <div v-for="(step, index) in flowSteps" :key="index" class="flow-step">
          <div class="flow-step__number">{{ index + 1 }}</div>
          <div class="flow-step__content">
            <h4 class="flow-step__title">{{ step.title }}</h4>
            <p class="flow-step__description">{{ step.description }}</p>
          </div>
        </div>
      </div>
      
      <div class="flow-cta">
        <base-button
          variant="primary"
          size="lg"
          to="/reserve"
          icon="fas fa-calendar-check"
        >
          ご予約・見学受付をする
        </base-button>
      </div>
    </div>
  </base-section>
</template>

<script>
import BaseSection from '@/components/common/BaseSection.vue';
import BaseButton from '@/components/common/BaseButton.vue';

export default {
  name: 'FlowSection',
  components: {
    BaseSection,
    BaseButton
  },
  data() {
    return {
      flowSteps: [
        {
          title: '見学予約',
          description: 'まずは無料見学でサロンの雰囲気をご確認ください。オンラインフォームから簡単にご予約いただけます。'
        },
        {
          title: 'サロン見学',
          description: '初めての方には、当サロンルームがどのような雰囲気か体験していただけるよう、必ず事前に見学をお願いしております。まずはお気軽にご見学ください。下記フォームより承っております。※事前に必ず見学をお願いします【平日10時から11時頃でお願いしています】'
        },
        {
          title: '見学時または予約専用ページからご予約',
          description: '見学時または予約専用ページからご予約ください。必要項目を入力いただき送信してください。追って完了メールが送信されます。'
        },
        {
          title: '予約完了後のメール確認',
          description: 'メールの内容を確認の上、実際のご予約日時を確定いたします。流れはメールに記載がございますので、ご完了まで進めてください。ご利用料金のお支払いをお願い致します。※クレジットカードまたは銀行振込み決済となります。'
        },
        {
          title: '当日ご利用開始',
          description: '入り口の鍵にて入室ください。使用後は、次にご利用される方のために、規定に沿って清掃・片付けにご協力ください。またのご利用をお待ちしております。'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.flow-section {
  max-width: 800px;
  margin: 0 auto;
}

.flow-steps {
  position: relative;
  padding-left: $spacing-xl;
  
  &::before {
    content: '';
    position: absolute;
    left: 20px;
    top: 30px;
    bottom: 30px;
    width: 2px;
    background-color: $gray-300;
    
    @include media-breakpoint-down(sm) {
      left: 15px;
    }
  }
}

.flow-step {
  display: flex;
  align-items: flex-start;
  margin-bottom: $spacing-2xl;
  position: relative;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  &__number {
    @include flex-center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    background-color: $primary-color;
    color: $white;
    font-weight: 600;
    border-radius: $radius-full;
    margin-right: $spacing-lg;
    position: relative;
    z-index: 1;
    font-size: $font-size-lg;
    
    @include media-breakpoint-down(sm) {
      width: 30px;
      height: 30px;
      font-size: $font-size-md;
      margin-right: $spacing-md;
    }
  }
  
  &__content {
    flex: 1;
    background-color: $white;
    padding: $spacing-lg;
    border-radius: $radius-lg;
    box-shadow: $shadow-sm;
  }
  
  &__title {
    font-size: $font-size-xl;
    font-weight: 600;
    color: $primary-color;
    margin-bottom: $spacing-sm;
    
    @include media-breakpoint-down(sm) {
      font-size: $font-size-lg;
    }
  }
  
  &__description {
    color: $gray-700;
    line-height: 1.6;
    margin-bottom: 0;
    font-size: $font-size-md;
    
    @include media-breakpoint-down(sm) {
      font-size: $font-size-sm;
    }
  }
}

.flow-cta {
  text-align: center;
  margin-top: $spacing-3xl;
}
</style>